import { useEffect } from 'react';

interface UseMetaDescriptionProps {
  description: string;
  baseDescription?: string;
}

export const useMetaDescription = ({ 
  description, 
  baseDescription = 'Web site created using create-react-app' 
}: UseMetaDescriptionProps) => {
  useEffect(() => {
    // Busca ou cria o meta tag de description
    let metaDescription = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    
    // Salva a description anterior
    const previousDescription = metaDescription.content;
    
    // Define a nova description
    metaDescription.content = description;
    
    return () => {
      // Restaura a description anterior
      metaDescription.content = previousDescription;
    };
  }, [description]);
};
